import { Checkbox } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import React from 'react'

const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const OptionWithCheckBox = ({option, selected}) => {
  return (
    <>
      <Checkbox
        size='small'
        checkedIcon={checkedIcon}
        style={{ marginRight: 8 }}
        checked={!!selected}
      />
      <span style={{ fontSize: 14 }}>{option.name}</span>
    </>
  )
}
